// extracted by css-extract-rspack-plugin
export default {"glyphHover":"CompletionIcon_glyphHover__3v0Zb","completionClickable":"CompletionIcon_completionClickable__g2eG5","glyphRest":"CompletionIcon_glyphRest__IzWZp"};